import React from "react";

/**
 * @component SystemSettingsIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <SystemSettingsIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const SystemSettingsIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="SystemSettingsIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.75 2a2 2 0 00-2 2v.154l-.029-.029a2 2 0 00-2.828 0L4.125 5.893a2 2 0 000 2.828l.029.029H4a2 2 0 00-2 2v2.5a2 2 0 002 2h.314l-.189.189a2 2 0 000 2.828l1.768 1.768a2 2 0 002.828 0l.029-.029A1.998 1.998 0 0010.748 22h2.502a2 2 0 002-2v-.154l.189.189a2 2 0 002.828 0l1.768-1.768a2 2 0 000-2.828l-.189-.189H20a2 2 0 002-2v-2.502a1.998 1.998 0 00-1.994-1.998l.029-.029a2 2 0 000-2.828l-1.768-1.768a2 2 0 00-2.828 0l-.189.189V4a2 2 0 00-2-2h-2.5zm0 2h2.5v.314c0 1.782 2.154 2.674 3.414 1.414l.189-.189 1.768 1.768-.032.032C17.33 8.597 18.22 10.749 20 10.75v2.5h-.154c-1.782 0-2.674 2.154-1.414 3.414l.189.189-1.768 1.768-.189-.189c-1.26-1.26-3.414-.368-3.414 1.414V20h-2.5c-.001-1.779-2.153-2.67-3.411-1.411l-.032.032-1.768-1.768.189-.189c1.26-1.26.368-3.414-1.414-3.414H4v-2.5h.154c1.782 0 2.674-2.154 1.414-3.414l-.029-.029 1.768-1.768.029.029c1.26 1.26 3.414.368 3.414-1.414V4zM10 12a2 2 0 114 0 2 2 0 01-4 0zm2-4a4 4 0 100 8 4 4 0 000-8z"
      />
    </svg>
  )
);
SystemSettingsIcon.displayName = "SystemSettingsIcon";
export default SystemSettingsIcon;
